angular.module('invoice')
    .component('invoiceAccessGroupList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/invoice/access-group/list.html',
        controller: function ($scope, $state, InvoiceAccessGroupService, InvoiceAccessGroupConst) {
            this.reset = () => this.filters = {}
            this.InvoiceAccessGroupService = InvoiceAccessGroupService
            $scope.$on(InvoiceAccessGroupConst.eventUpdate, () => $state.reload())
        }
    })
